import { render } from "./BaseInputRange.vue?vue&type=template&id=dec7b1de&scoped=true"
import script from "./BaseInputRange.vue?vue&type=script&lang=js"
export * from "./BaseInputRange.vue?vue&type=script&lang=js"

import "./BaseInputRange.vue?vue&type=style&index=0&id=dec7b1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec7b1de"]])

export default __exports__